import React, { useState } from 'react';
import { Dialog, DialogContent, Box, useMediaQuery, useTheme } from '@mui/material';
import PropTypes from 'prop-types';

// Importação de subcomponentes
import ModalHeader from './modal-header';
import ModalBackdrop from './modal-backdrop';
import { ModalProvider } from './modal-context';
import { styled } from '@mui/styles';

const Modal = ({
  open,
  onClose,
  id,
  title,
  children,
  maxWidth = 'sm',
  hideCloseButton = false,
  fullScreenOnMobile = true,
  backdrop = 'default',
  animation = 'fade',
  contentPadding = true
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [animationComplete, setAnimationComplete] = useState(false)

  // Determina se deve usar tela cheia em dispositivos móveis
  const fullScreen = fullScreenOnMobile && isMobile;

  // Funções para animação
  const handleEnterAnimation = () => {
    setTimeout(() => setAnimationComplete(true), 300)
  }

  const handleExitAnimation = () => {
    setAnimationComplete(false)
  }

  return (
    <ModalProvider value={{ onClose }}>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth={maxWidth}
        fullScreen={fullScreen}
        fullWidth
        TransitionProps={{
          onEnter: handleEnterAnimation,
          onExited: handleExitAnimation,
        }}
        PaperProps={{
          elevation: 8,
          sx: {
            borderRadius: fullScreen ? 0 : 2,
            overflow: 'hidden',
            background: theme.palette.background.paper,
            transition: theme.transitions.create(['transform', 'opacity'], {
              duration: theme.transitions.duration.standard,
            }),
            ...(animation === 'slide' && {
              transform: animationComplete ? 'translateY(0)' : 'translateY(32px)',
            }),
          },
        }}
        BackdropComponent={backdrop !== 'default' ? ModalBackdrop : undefined}
      >
        {/* Cabeçalho do Modal */}
        {(title || !hideCloseButton) && (
          <ModalHeader
            id={id}
            title={title}
            onClose={hideCloseButton ? undefined : onClose}
          />
        )}

        {/* Conteúdo do Modal */}
        <DialogContent
          className="dialog-content-external"
          sx={{
            p: contentPadding ? theme.spacing(3) : 0,
            [theme.breakpoints.down('sm')]: {
              p: contentPadding ? theme.spacing(2) : 0,
            },
          }}
        >
          {children}
        </DialogContent>
      </Dialog>
    </ModalProvider>
  );
};

Modal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  children: PropTypes.node,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      variant: PropTypes.string,
      color: PropTypes.string,
      startIcon: PropTypes.node,
      endIcon: PropTypes.node,
      autoFocus: PropTypes.bool,
    })
  ),
  hideCloseButton: PropTypes.bool,
  fullScreenOnMobile: PropTypes.bool,
  backdrop: PropTypes.oneOf(['default', 'blur', 'gradient']),
  animation: PropTypes.oneOf(['fade', 'slide']),
};

export default Modal;